import React, {Component} from 'react';
import axios from 'axios';
import {connect} from "react-redux";
import css from './PhotoPack.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { fetchS3Photos, uploadSinglePhoto } from '../../utils/awsHelper';
import PhotoGeoChecker from "../../utils/photoGeoChecker";

/**
 * @class
 *
 * PhotoPack page.
 */
const InstallPhotoPack = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();
    opportunityId = this.props.opportunityId;
    sessId = this.props.sessId;
    type = this.props.type;
    s3;
    username = this.props.user.name;
    SF_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";

    postRequestOpp = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Company__c",
            "Substantial__c",
            "Substantial__r.Name",
            "Ground_Mount__c",
            "Days_to_Clawback__c",
            "Site_Visits__c",
            "Location__r.Name",
            "Safe_Harbor_Needed__c"
        ],
        "where": {
            "Id": this.opportunityId
        }
    };

    postRequestSession = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Field_Job__c",
            "Field_Job__r.Clocked_End__c",
            "Field_Job__r.Install_Outcome__c",
            "Assigned_Crew__r.Work_Phone_Number__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    postRequestWorkOrder = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Assigned_Field_Team__c", 
            "Assigned_Field_Team__r.Tech_1__c",
            "Assigned_Field_Team__r.Tech_1__r.Work_Phone_Number__c",
            "Review_Submitted__c",
            "Number_of_Days__c"
        ],
        "where": {
            "Id": this.sessId
        }
    };

    state = {
        preview: false,
        previewPic: {},
        previewPics: [],
        filesToUpload: [],
        uploading: false,
        fileUploadCounter: 0,
        opp: {},
        session: {},
        slackResponse: '',
        sendingToSlack: false,
        tier3rtr: false,
        isPast6PM: false,
        isWorkOrder: false,

        errorMessage: '',

        showSafeHarborSNs: false,
        SafeHarborSNsArray:[],
        SafeHarborSNsError: false,

        Safety:{},
        SafetyError: false,

        FHAddress:{},
        FHAddressError: false,

        RailMount:{},
        RailMountError: false,

        RailMountArray: [],

        TileMount:{},
        TileMountError: false,

        TileMountArray: [],

        RoofRacking:{},
        RoofRackingError: false,

        RoofRackingArray: [],

        Grounding:{},
        GroundingError: false,

        GroundingArray: [],

        OptimizerModelRating: {},
        OptimizerModelRatingError: false,

        OptimizerMap: {},
        OptimizerMapError: false,

        OptimizerMapArray: [],

        JBox: {},
        JBoxError: false,

        JBoxWiring: {},
        JBoxWiringError: false,

        JBoxCover:{},
        JBoxCoverError: false,

        ConduitPath:{},
        ConduitPathError: false,

        ConduitPathArray: [],

        ConduitFlashing:{},
        ConduitFlashingError: false,

        ConduitFlashingArray: [],
        RoofArray:{},
        RoofArrayError: false,

        RoofArrayArray: [],

        SolarModuleLabel:{},
        SolarModuleLabelError: false,

        ArrayTilt:{},
        ArrayTiltError: false,

        ArrayTiltArray: [],

        ModuleAttchMidClamp:{},
        ModuleAttchMidClampError: false,

        ModuleAttchEndClamp:{},
        ModuleAttchEndClampError: false,

        UnderArrayWireMgmt:{},
        UnderArrayWireMgmtError: false,

        UnderArrayWireMgmtArray: [],

        PullBackPanelLabel: {},
        PullBackPanelLabel: false,

        PVModuleInfrontofAddress:{},
        PVModuleInfrontofAddress: false,

        ModuleRailBonding:{},
        ModuleRailBondingError: false,

        EVChargerModelWiring:{},
        EVChargerModelWiringError: false,

        TransferSwitchModelWiring: {},
        TransferSwitchModelWiringError: false,

        CADChanges: {},
        CADChangesError: false,
        CADChangesArray: [],

        YardSign: {},
        YardSignError: false
    }

    // ---------- life cycle methods: ----------
    async componentDidMount() {
        window.scrollTo(0, 0);

        fetchS3Photos({
            recordId: this.opportunityId,
            type: '/' + this.type,
            process: 'getDocs',
            existingState: this.state,
            source: this.source
        })
        .then(newState => {
            this.setState(newState);
        })
        .catch(err => {
            console.error('AWS S3 fetch error:', err);
            this.setState({ errorMessage: err.message });
        });

        const now = new Date();
        const pstTime = moment(now, "America/Los_Angeles");
        if (pstTime.hour() >= 18) {
            this.setState({ isPast6PM: true });
        }

        await this.getOpp();

        const isWorkOrder = this.sessId.startsWith('a0j');
        this.setState({ isWorkOrder });

        if (isWorkOrder) {
            await this.getWorkOrder();
        } else {
            await this.getSession();
        }
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getOpp = async() => {
        axios.post(
            '/sf/opportunity/findNo',
            this.postRequestOpp,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                this.setState({opp: data});

                if((data.Days_to_Clawback__c !== null && data.Days_to_Clawback__c < 30) || data.Site_Visits__c >= 6 || data.Ground_Mount__c === true) {
                    this.setState({tier3rtr: true});
                }

                if(data.Safe_Harbor_Needed__c !== null){
                    this.setState({showSafeHarborSNs: true});
                }
            })
            .catch(err => console.log('POST Error Opp:\n', err));
    };

    getSession = async() => {
        axios.post(
            '/sf/schedulable/findNo',
            this.postRequestSession,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    };

    getWorkOrder = async() => {
        axios.post(
            '/sf/WorkOrder/findNo',
            this.postRequestWorkOrder,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];

                this.setState({session: data});
            })
            .catch(err => console.log('POST Error Session:\n', err));
    }

    capturePhoto = async(file, stateName, stateNameError) => {
        if (!file || this.state.uploading) return;
        
        try {
            await uploadSinglePhoto({
                file,
                stateName,
                stateNameError,
                username: this.username,
                opportunityId: this.opportunityId,
                type: this.type,
                setState: this.setState.bind(this),
                source: this.source
            });
        } catch(err){
            console.log(err)
        }
    };

    bulkUpload = async (files, arrayName, picNames, stateNameError) => {
        const currentArray = this.state[arrayName] || [];
        const updatedArray = [...currentArray];
        const filesToUploadArray = [];

        let existingSizes = new Set();
        let safeHarborPhotosUploaded = false;

        // Only run duplicate-by-size logic for SafeHarborSNsArray
        if(arrayName === 'SafeHarborSNsArray' && currentArray.length > 0) {
            try {
                for(let i = 0; i < currentArray.length; i++) {
                    try {
                        const exisitingUrl = this.state[currentArray[i]];
                        const key = exisitingUrl.split('https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/');

                        const payload = {
                            method: 'HEAD',
                            process: 'getUrl',
                            bucket: 'v3-portal-file-storage',
                            key: key[1],
                            expiresSec: 60,
                            RecordId: this.opportunityId
                        };

                        const res = await axios.post('/postAWS', payload, { cancelToken: this.source.token });
                        const url = res?.data?.key;
                        if (!url) throw new Error('Missing presigned URL');
                        const headRes = await fetch(url, { method: 'HEAD' });

                        if (!headRes.ok) {
                            throw new Error(`HEAD ${headRes.status} ${headRes.statusText}`);
                        }

                        const len = headRes.headers.get('content-length');
                        if (len) existingSizes.add(Number(len));
                    } catch (err) {
                        console.error('Presigned HEAD check failed:', err);
                    }
                }
            } catch (err) {
                console.error('Failed to fetch existing photos:', err);
            }
        }

        const skippedFiles = [];
        for(const file of files) {
            if(arrayName === 'SafeHarborSNsArray'){
                const fileSize = Number(file.size);
                if(existingSizes.has(fileSize)) {
                    skippedFiles.push({ name: file.name, reason: 'Duplicate Photo'});
                    continue;
                }

                const hasGeotag = await PhotoGeoChecker.hasGeo(file);
                if(!hasGeotag) {
                    skippedFiles.push({ name: file.name, reason: 'No Geotag Found'});
                    continue
                }

                // setting to true if there was at least one SH photo that passed both duplicate and geotag validation.
                safeHarborPhotosUploaded = true;
            }

            filesToUploadArray.push(file);
        }

        this.setState({
            bulkUploading: true,
            uploadProgress: { done: 0, total: filesToUploadArray.length },
            errorMessage: ''
        });

        let nextNumber = updatedArray.length + 1;

        try {
            for (const file of filesToUploadArray) {
                const picName = `${picNames}${nextNumber}`;

                try {
                    await this.capturePhoto(file, picName, stateNameError);
                    updatedArray.push(picName);
                    nextNumber++;
                } catch (err) {
                    console.error(`Failed to upload ${picName}:`, err);
                } finally {
                    // update progress after each attempt
                    this.setState(prev => ({
                        uploadProgress: {
                            done: Math.min((prev.uploadProgress?.done || 0) + 1, filesToUploadArray.length),
                            total: filesToUploadArray.length
                        }
                    }));
                }
            }
            this.setState({ [arrayName]: updatedArray });
        } finally {
            this.setState({ bulkUploading: false });
        }

        if(skippedFiles.length > 0) {
            const message =
                `These files were not uploaded:\n` +
                skippedFiles.map((f) => `- "${f.name}", reason: "${f.reason}"`).join('\n');
            this.setState({ errorMessage: message });
        }

        if(safeHarborPhotosUploaded) {
            try {
                await axios.put('/sf/WorkOrder/update', {
                    Id: this.sessId,
                    Safe_Harbor_SNs_Photos_Uploaded__c: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                });
            } catch (err) {
                console.log('PUT Error Work Order:\n', err);
            }
        }
    };

    previewImage = (e) => {
        let img = e;
        this.setState({previewPic: img, preview:true});
    };

    addAnotherPic = (array, fileName, displayName) => {
        let picNumber = this.state[array].length + 1;
        let stateName = fileName + picNumber.toString();
        this.setState({
            [array]: [...this.state[array], stateName],
            [stateName] : {}
        })
    };

    sendToSlack = () => {
        this.setState({sendingToSlack: true});

        let message = 'Roof Photos Review for: <https://v3electric.my.site.com/frontendOps/s/detail/' +  this.state.opp.Id + '|' +  this.state.opp.Name +'>\n' +
            'Field Tech: ' + this.props.user.name + '\n' +
            'Photo Pack Page: <https://v3electric.my.site.com/frontendOps/s/sfdcpage/%2Fapex%2FPhotoPackOppS3%3F%26id%3D' + this.state.opp.Id + '|Photo Pack>\n' +
            'Work Order: <https://v3electric.my.site.com/frontendOps/s/detail/' + this.state.session.Id + '|' +  this.state.session.Name +'>\n' +
            'Substantial: <https://v3electric.my.site.com/frontendOps/s/detail/' + this.state.opp.Substantial__c + '|' +  this.state.opp.Substantial__r.Name +'>\n' +
            'Financier: ' + this.state.opp.Company__c + '\n' +
            'Location: ' + this.state.opp.Location__r.Name + '\n' +
            'Number of Days: ' + this.state.session.Number_of_Days__c;

        // test-api channel id C06JN84MGFM
        // tier 1 rtr id: C07UMTF64TE
        // tier 2 rtr id: C07UGHTQ7M3
        // tier 3 rtr id: C07V87JGTFS

        let channelId = '';

        if((this.state.opp.Days_to_Clawback__c > 30 || this.state.opp.Days_to_Clawback__c === null) && this.state.opp.Site_Visits__c < 6 && this.state.opp.Ground_Mount__c === false){
            channelId = 'C07UGHTQ7M3'; // tier 2
        } else if((this.state.opp.Days_to_Clawback__c !== null && this.state.opp.Days_to_Clawback__c < 30) || this.state.opp.Site_Visits__c >= 6 || this.state.opp.Ground_Mount__c === true) {
            channelId = 'C07V87JGTFS'; // tier 3
            if(this.state.isWorkOrder){
                message = message + '\nTechs Work Phone Number: ' + this.state.session.Assigned_Field_Team__r.Tech_1__r.Work_Phone_Number__c;
            } else {
                message = message + '\nTechs Work Phone Number: ' + this.state.session.Assigned_Crew__r.Work_Phone_Number__c;
            }
        } else {
            channelId = 'C07UMTF64TE'; // default to tier 1
        }

        let payload = {
            "channel": channelId,
            "text": message
        };

        axios.post(
            '/slackMessage', 
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.setState({slackResponse: 'Notification sent to Slack successfully', sendingToSlack: false});

                let subPayload = {
                    Id: this.state.opp.Substantial__c,
                    Install_Review_SubmittedDT__c: moment()
                };

                axios.put(
                    '/sf/substantial/update',
                    subPayload,
                    {
                        cancelToken: this.source.token
                    }).then((res) => {
                        
                    })
                    .catch(err => console.log('PUT Error updating substantial:\n', err))

                // Review Submitted on WO is used for reporting on when field team initially requested RTR.
                if(this.state.isWorkOrder && !this.state.session.Review_Submitted__c){
                    let woPayload = {
                        Id: this.sessId,
                        Review_Submitted__c: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
                    };

                    axios.put(
                        '/sf/WorkOrder/update', 
                        woPayload, 
                        {
                            cancelToken: this.source.token
                        })
                        .catch(err => console.log('PUT Error Updating WO on RTR Request:\n', err));
                }

                setTimeout(() => {
                    this.setState({slackResponse: ''});
                }, 3000);
            })
            .catch(err => {
                console.log('POST Error Sending Slack Message:\n', err);
                this.setState({slackResponse: 'Failed to send to Slack: ' + err.message, sendingToSlack: false});
            });
    };

    render() {
        return (
            <div className={css.PhotoPack}>
                <h1 className='pb-3'>{this.type} Photo Pack</h1>
                <h2 className='text-white pb-3'>Please Ensure HEIC is turned off as the format isn't readily sharable</h2>
                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'} style={{ whiteSpace: 'pre-line' }}>Error: {this.state.errorMessage}</h2>

                {
                    this.state.preview ? 
                    <div>
                        <div>
                            <img className={css.PhotoPack__PreviewImg} src={this.state.previewPic} alt="Preview of upload" />
                        </div>
                        <div className='pt-3'>
                            <button className='btn btn-primary' onClick={() => this.setState({preview: false, previewPic: {}})}>Close Preview</button>
                        </div>
                    </div>

                    :

                    <div>
                        {/* Slack div to send messages */}
                        <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div>
                        {
                            this.state.tier3rtr ? 
                                this.state.isPast6PM ? 
                                <h2 className='text-white pb-3'>This is a Tier 3 project. Reviewers are unavailable at this time. Please be prepared to have a phone review tomorrow morning.</h2>
                                :
                                <h2 className='text-white pb-3'>This is a Tier 3 project. Please sit tight until you receive a call from the RTR team to conduct the review.</h2>
                                :
                                <></>
                        }

                        <table>
                            <tbody>
                                {/* Safe Harbor Serial Number(s) */}
                                <tr className={(this.state.showSafeHarborSNs || this.state.SafeHarborSNsArray && this.state.SafeHarborSNsArray.length !== 0) ?  "" : "d-none"}>
                                    <td className="w-50">
                                        {
                                        this.state.SafeHarborSNsError ?
                                        <div className='text-error'>
                                            <FontAwesomeIcon icon={faCircle} /> Error Uploading Safe Harbor Serial Number(s): <br />{this.state.errorMessage}
                                        </div>
                                        :
                                        <div className='text-warningC'>
                                            <FontAwesomeIcon icon={faCircle} /> Safe Harbor Serial Number(s)
                                        </div>
                                        }
                                    </td>
                                    <td className="w-25">
                                        <label htmlFor="SafeHarborSNsUpload" className="btn btn-primary">
                                            <div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>
                                            Bulk Upload
                                        </label>
                                        <input
                                            className={css.PhotoPack__PicInput}
                                            id="SafeHarborSNsUpload"
                                            type="file"
                                            accept="image/*"
                                            disabled={this.state.uploading}
                                            multiple
                                            onChange={(event) => this.bulkUpload(
                                                event.target.files,
                                                'SafeHarborSNsArray',
                                                'SafeHarborSNs-',
                                                'SafeHarborSNsError'
                                            )}
                                        />
                                    </td>
                                    <td></td>
                                </tr>

                                {
                                this.state.SafeHarborSNsArray && this.state.SafeHarborSNsArray.length !== 0 ?
                                    this.state.SafeHarborSNsArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                Object.keys(this.state[t] || {}).length === 0
                                                ?
                                                <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                :
                                                <button
                                                    className='btn btn-outline text-green btn-text'
                                                    onClick={() => this.previewImage(this.state[t])}
                                                >
                                                    <FontAwesomeIcon icon={faCircle} /> {t}
                                                </button>
                                                }
                                            </td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    )
                                :
                                    <></>
                                }

                                {/* Safety Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.Safety).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Safety</div>
                                            :
                                            this.state.SafetyError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Safety: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.Safety)}><FontAwesomeIcon icon={faCircle} /> Safety</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="Safety" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="Safety" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'Safety', 'SafetyError')} /></td>
                                    <td className="w-25"><label htmlFor="SafetyUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SafetyUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'Safety', 'SafetyError')}/></td>
                                </tr>

                                {/* Front House Address Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.FHAddress).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Front of House Address: Photo showing house numbers (must match the plans)</div>
                                            :
                                            this.state.FHAddressError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Front of House Address: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.FHAddress)}><FontAwesomeIcon icon={faCircle} /> Front of House Address: Photo showing house numbers (must match the plans)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="FHAddress" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="FHAddress" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'FHAddress', 'FHAddressError')} /></td>
                                    <td className="w-25"><label htmlFor="FHAddressUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="FHAddressUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'FHAddress', 'FHAddressError')}/></td>
                                </tr>

                                {/* Rail Mount Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.RailMount).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Rail Mount Flashing: Flashed footing for rail attachment</div>
                                            :
                                            this.state.RailMountError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Rail Mount Flashing: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.RailMount)}><FontAwesomeIcon icon={faCircle} /> Rail Mount Flashing: Flashed footing for rail attachment</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="RailMount" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="RailMount" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'RailMount', 'RailMountError')} /></td>
                                    <td className="w-25"><label htmlFor="RailMountUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="RailMountUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'RailMount', 'RailMountError')}/></td>
                                </tr>

                                {/* Rail Mount Array Photos */}
                                {
                                    this.state.RailMountArray.length !== 0 ? 
                                    
                                    this.state.RailMountArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Rail Mount Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('RailMountArray', 'RailMount-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Tile Mount Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.TileMount).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Tile Mount and Flashing Tape: Tac spray should be evident in the photo. Tile replacement flashing should sit flush with the tile and show no damages.</div>
                                            :
                                            this.state.TileMountError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Tile Mount and Flashing Tape: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.TileMount)}><FontAwesomeIcon icon={faCircle} /> Tile Mount and Flashing Tape: Tac spray should be evident in the photo. Tile replacement flashing should sit flush with the tile and show no damages.</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="TileMount" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="TileMount" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'TileMount', 'TileMountError')} /></td>
                                    <td className="w-25"><label htmlFor="TileMountUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="TileMountUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'TileMount', 'TileMountError')}/></td>
                                </tr>

                                {/* Tile Mount Photos */}
                                {
                                    this.state.TileMountArray.length !== 0 ? 
                                    
                                    this.state.TileMountArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Tile Mount Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('TileMountArray', 'TileMount-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Roof Racking Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.RoofRacking).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Roof Structural (racking): Completed Rails attached to the mounts on roof (At least one per array)</div>
                                            :
                                            this.state.RoofRackingError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Roof Structural (racking): <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.RoofRacking)}><FontAwesomeIcon icon={faCircle} /> Roof Structural (racking): Completed Rails attached to the mounts on roof (At least one per array)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="RoofRacking" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="RoofRacking" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'RoofRacking', 'RoofRackingError')} /></td>
                                    <td className="w-25"><label htmlFor="RoofRackingUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="RoofRackingUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'RoofRacking', 'RoofRackingError')}/></td>
                                </tr>

                                {/* Roof Racking Photos */}
                                {
                                    this.state.RoofRackingArray.length !== 0 ? 
                                    
                                    this.state.RoofRackingArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Roof Racking Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('RoofRackingArray', 'RoofRacking-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Grounding Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.Grounding).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Grounding: Conduit to rail and panel to panel for Ecofasten. Unirac and Ironridge grounding should be rail to rail</div>
                                            :
                                            this.state.GroundingError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Grounding: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.Grounding)}><FontAwesomeIcon icon={faCircle} /> Grounding: Conduit to rail and panel to panel for Ecofasten. Unirac and Ironridge grounding should be rail to rail</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="Grounding" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="Grounding" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'Grounding', 'GroundingError')} /></td>
                                    <td className="w-25"><label htmlFor="GroundingUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="GroundingUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'Grounding', 'GroundingError')}/></td>
                                </tr>

                                {/* Grounding Array Photos */}
                                {
                                    this.state.GroundingArray.length !== 0 ? 
                                    
                                    this.state.GroundingArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Grounding Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('GroundingArray', 'Grounding-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Optimizer Model and Rating Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.OptimizerModelRating).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Optimizer Model # and Rating: Photo showing both rating and model # of opti used. Enphase Systems: Photo of microinverter model number with bar code</div>
                                            :
                                            this.state.OptimizerModelRatingError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Optimizer Model # and Rating: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.OptimizerModelRating)}><FontAwesomeIcon icon={faCircle} /> Optimizer Model # and Rating: Photo showing both rating and model # of opti used. Enphase Systems: Photo of microinverter model number with bar code</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="OptimizerModelRating" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="OptimizerModelRating" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'OptimizerModelRating', 'OptimizerModelRatingError')} /></td>
                                    <td className="w-25"><label htmlFor="OptimizerModelRatingUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="OptimizerModelRatingUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'OptimizerModelRating', 'OptimizerModelRatingError')}/></td>
                                </tr>

                                {/* Optimizer Map Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.OptimizerMap).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Optimizer Map: Visual map for optimizer placement on roof. Should be laid out according to the plans/install and placement true and accurate</div>
                                            :
                                            this.state.OptimizerMapError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Optimizer Map: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.OptimizerMap)}><FontAwesomeIcon icon={faCircle} /> Optimizer Map: Visual map for optimizer placement on roof. Should be laid out according to the plans/install and placement true and accurate</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="OptimizerMap" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="OptimizerMap" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'OptimizerMap', 'OptimizerMapError')} /></td>
                                    <td className="w-25"><label htmlFor="OptimizerMapUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="OptimizerMapUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'OptimizerMap', 'OptimizerMapError')}/></td>
                                </tr>

                                {/* Optimizer Map Array Photos */}
                                {
                                    this.state.OptimizerMapArray.length !== 0 ? 
                                    
                                    this.state.OptimizerMapArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Optimizer Map Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('OptimizerMapArray', 'OptimizerMap-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* J-Box Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.JBox).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> J-Box: Interior photo showing weep holes visible</div>
                                            :
                                            this.state.JBoxError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading J-Box: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.JBox)}><FontAwesomeIcon icon={faCircle} /> J-Box: Interior photo showing weep holes visible</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="JBox" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="JBox" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'JBox', 'JBoxError')} /></td>
                                    <td className="w-25"><label htmlFor="JBoxUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="JBoxUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'JBox', 'JBoxError')}/></td>
                                </tr>

                                {/* J-Box Wiring Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.JBoxWiring).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> J-Box Wiring: Interior with completed wiring inside the box</div>
                                            :
                                            this.state.JBoxWiringError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading J-Box Wiring: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.JBoxWiring)}><FontAwesomeIcon icon={faCircle} /> J-Box Wiring: Interior with completed wiring inside the box</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="JBoxWiring" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="JBoxWiring" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'JBoxWiring', 'JBoxWiringError')} /></td>
                                    <td className="w-25"><label htmlFor="JBoxWiringUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="JBoxWiringUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'JBoxWiring', 'JBoxWiringError')}/></td>
                                </tr>

                                {/* J-Box Cover Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.JBoxCover).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> J-Box with cover on</div>
                                            :
                                            this.state.JBoxCoverError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading J-Box with cover on: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.JBoxCover)}><FontAwesomeIcon icon={faCircle} /> J-Box with cover on</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="JBoxCover" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="JBoxCover" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'JBoxCover', 'JBoxCoverError')} /></td>
                                    <td className="w-25"><label htmlFor="JBoxCoverUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="JBoxCoverUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'JBoxCover', 'JBoxCoverError')}/></td>
                                </tr>

                                {/* Conduit Path Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ConduitPath).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Conduit Path on Roof: Conduit path with supports every 5ft</div>
                                            :
                                            this.state.ConduitPathError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Conduit Path on Roof: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ConduitPath)}><FontAwesomeIcon icon={faCircle} /> Conduit Path on Roof: Conduit path with supports every 5ft</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="ConduitPath" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ConduitPath" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ConduitPath', 'ConduitPathError')} /></td>
                                    <td className="w-25"><label htmlFor="ConduitPathUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ConduitPathUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ConduitPath', 'ConduitPathError')}/></td>
                                </tr>

                                {/* Conduit Path Array Photos */}
                                {
                                    this.state.ConduitPathArray.length !== 0 ? 
                                    
                                    this.state.ConduitPathArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Conduit Path Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('ConduitPathArray', 'ConduitPath-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Conduit Flashing Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ConduitFlashing).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Conduit Penetration Flashing: Washer sealed at the roof deck and Ground to roof penetration flashing</div>
                                            :
                                            this.state.ConduitFlashingError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Conduit Penetration Flashing: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ConduitFlashing)}><FontAwesomeIcon icon={faCircle} /> Conduit Penetration Flashing: Washer sealed at the roof deck and Ground to roof penetration flashing</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="ConduitFlashing" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ConduitFlashing" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ConduitFlashing', 'ConduitFlashingError')} /></td>
                                    <td className="w-25"><label htmlFor="ConduitFlashingUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ConduitFlashingUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ConduitFlashing', 'ConduitFlashingError')}/></td>
                                </tr>

                                {/* Conduit Flashing Photos */}
                                {
                                    this.state.ConduitFlashingArray.length !== 0 ? 
                                    
                                    this.state.ConduitFlashingArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Conduit Flashing Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('ConduitFlashingArray', 'ConduitFlashing-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Roof Array Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.RoofArray).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Roof Array(s): Photos for each array of panels on the roof with each panel countable in its entirety</div>
                                            :
                                            this.state.RoofArrayError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Roof Array: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.RoofArray)}><FontAwesomeIcon icon={faCircle} /> Roof Array(s): Photos for each array of panels on the roof with each panel countable in its entirety</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="RoofArray" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="RoofArray" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'RoofArray', 'RoofArrayError')} /></td>
                                    <td className="w-25"><label htmlFor="RoofArrayUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="RoofArrayUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'RoofArray', 'RoofArrayError')}/></td>
                                </tr>

                                {/* Roof Array Photos */}
                                {
                                    this.state.RoofArrayArray.length !== 0 ? 
                                    
                                    this.state.RoofArrayArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Roof Array Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('RoofArrayArray', 'RoofArray-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Solar Module Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.SolarModuleLabel).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Solar Module Label: Label showing manufacturer, Panel type and wattage</div>
                                            :
                                            this.state.SolarModuleLabelError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Solar Module Label: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.SolarModuleLabel)}><FontAwesomeIcon icon={faCircle} /> Solar Module Label: Label showing manufacturer, Panel type and wattage</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="SolarModuleLabel" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="SolarModuleLabel" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'SolarModuleLabel', 'SolarModuleLabelError')} /></td>
                                    <td className="w-25"><label htmlFor="SolarModuleLabelUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="SolarModuleLabelUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'SolarModuleLabel', 'SolarModuleLabelError')}/></td>
                                </tr>

                                {/* Array Tilts Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ArrayTilt).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Array Tilt(s): Tilt measurements for each array with no more than 5 degrees of variation from the plans</div>
                                            :
                                            this.state.ArrayTiltError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Array Tilt: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ArrayTilt)}><FontAwesomeIcon icon={faCircle} /> Array Tilt(s): Tilt measurements for each array with no more than 5 degrees of variation from the plans</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="ArrayTilt" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ArrayTilt" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ArrayTilt', 'ArrayTiltError')} /></td>
                                    <td className="w-25"><label htmlFor="ArrayTiltUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ArrayTiltUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ArrayTilt', 'ArrayTiltError')}/></td>
                                </tr>

                                {/* Array Tile Photos */}
                                {
                                    this.state.ArrayTiltArray.length !== 0 ? 
                                    
                                    this.state.ArrayTiltArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Array Tilt Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('ArrayTiltArray', 'ArrayTilt-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Module Attach Mid Clamp Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ModuleAttchMidClamp).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Module Attachments Mid Clamp</div>
                                            :
                                            this.state.ModuleAttchMidClampError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Module Attachments Mid Clamp: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ModuleAttchMidClamp)}><FontAwesomeIcon icon={faCircle} /> Module Attachments Mid Clamp</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="ModuleAttchMidClamp" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ModuleAttchMidClamp" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ModuleAttchMidClamp', 'ModuleAttchMidClampError')} /></td>
                                    <td className="w-25"><label htmlFor="ModuleAttchMidClampUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ModuleAttchMidClampUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ModuleAttchMidClamp', 'ModuleAttchMidClampError')}/></td>
                                </tr>

                                {/* Module Attach End Clamp Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ModuleAttchEndClamp).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Module Attachments End Clamp</div>
                                            :
                                            this.state.ModuleAttchEndClampError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Module Attachments End Clamp: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ModuleAttchEndClamp)}><FontAwesomeIcon icon={faCircle} /> Module Attachments End Clamp</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="ModuleAttchEndClamp" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ModuleAttchEndClamp" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ModuleAttchEndClamp', 'ModuleAttchEndClampError')} /></td>
                                    <td className="w-25"><label htmlFor="ModuleAttchEndClampUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ModuleAttchEndClampUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ModuleAttchEndClamp', 'ModuleAttchEndClampError')}/></td>
                                </tr>

                                {/* Under Array Wire Mgmt Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.UnderArrayWireMgmt).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Under Array Wire Management: Pictures for each row of panels showing wires are properly secured and not hanging below the rail</div>
                                            :
                                            this.state.UnderArrayWireMgmtError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Under Array Wire Management: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.UnderArrayWireMgmt)}><FontAwesomeIcon icon={faCircle} /> Under Array Wire Management: Pictures for each row of panels showing wires are properly secured and not hanging below the rail</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="UnderArrayWireMgmt" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="UnderArrayWireMgmt" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'UnderArrayWireMgmt', 'UnderArrayWireMgmtError')} /></td>
                                    <td className="w-25"><label htmlFor="UnderArrayWireMgmtUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="UnderArrayWireMgmtUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'UnderArrayWireMgmt', 'UnderArrayWireMgmtError')}/></td>
                                </tr>

                                {/* Under Array Wire Photos */}
                                {
                                    this.state.UnderArrayWireMgmtArray.length !== 0 ? 
                                    
                                    this.state.UnderArrayWireMgmtArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another Under Array Wire Mgmt Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('UnderArrayWireMgmtArray', 'UnderArrayWireMgmt-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Pull Back of Panel Label On Site Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.PullBackPanelLabel).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Pull Back of Panel Label On Site</div>
                                            :
                                            this.state.PullBackPanelLabelError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Pull Back of Panel Label On Site: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.PullBackPanelLabel)}><FontAwesomeIcon icon={faCircle} /> Pull Back of Panel Label On Site</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="PullBackPanelLabel" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="PullBackPanelLabel" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'PullBackPanelLabel', 'PullBackPanelLabelError')} /></td>
                                    <td className="w-25"><label htmlFor="PullBackPanelLabelUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="PullBackPanelLabelUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'PullBackPanelLabel', 'PullBackPanelLabelError')}/></td>
                                </tr>

                                {/* PV Module In front of Address Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.PVModuleInfrontofAddress).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> PV Module In Front of Address</div>
                                            :
                                            this.state.PVModuleInfrontofAddressError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading PV Module In Front of Address: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.PVModuleInfrontofAddress)}><FontAwesomeIcon icon={faCircle} /> PV Module In Front of Address</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="PVModuleInfrontofAddress" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="PVModuleInfrontofAddress" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'PVModuleInfrontofAddress', 'PVModuleInfrontofAddressError')} /></td>
                                    <td className="w-25"><label htmlFor="PVModuleInfrontofAddressUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="PVModuleInfrontofAddressUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'PVModuleInfrontofAddress', 'PVModuleInfrontofAddressError')}/></td>
                                </tr>

                                {/* Module to Module/Rail to Rail Bonding Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.ModuleRailBonding).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Module to Module/Rail to Rail Bonding</div>
                                            :
                                            this.state.ModuleRailBondingError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Module to Module/Rail to Rail Bonding: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.ModuleRailBonding)}><FontAwesomeIcon icon={faCircle} /> Module to Module/Rail to Rail Bonding</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="ModuleRailBonding" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="ModuleRailBonding" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'ModuleRailBonding', 'ModuleRailBondingError')} /></td>
                                    <td className="w-25"><label htmlFor="ModuleRailBondingUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="ModuleRailBondingUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'ModuleRailBonding', 'ModuleRailBondingError')}/></td>
                                </tr>

                                {/* EV Charger Model and Wiring (If Applicable) Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.EVChargerModelWiring).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> EV Charger Model and Wiring (If Applicable)</div>
                                            :
                                            this.state.EVChargerModelWiringError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading EV Charger Model and Wiring: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.EVChargerModelWiring)}><FontAwesomeIcon icon={faCircle} /> EV Charger Model and Wiring (If Applicable)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="EVChargerModelWiring" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="EVChargerModelWiring" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'EVChargerModelWiring', 'EVChargerModelWiringError')} /></td>
                                    <td className="w-25"><label htmlFor="EVChargerModelWiringUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="EVChargerModelWiringUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'EVChargerModelWiring', 'EVChargerModelWiringError')}/></td>
                                </tr>

                                {/* Transfer Switch Model and Wiring (If Applicable) Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.TransferSwitchModelWiring).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Transfer Switch Model and Wiring (If Applicable)</div>
                                            :
                                            this.state.TransferSwitchModelWiringError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading Transfer Switch Model and Wiring: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.TransferSwitchModelWiring)}><FontAwesomeIcon icon={faCircle} /> Transfer Switch Model and Wiring (If Applicable)</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="TransferSwitchModelWiring" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="TransferSwitchModelWiring" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'TransferSwitchModelWiring', 'TransferSwitchModelWiringError')} /></td>
                                    <td className="w-25"><label htmlFor="TransferSwitchModelWiringUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="TransferSwitchModelWiringUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'TransferSwitchModelWiring', 'TransferSwitchModelWiringError')}/></td>
                                </tr>

                                {/* CADChanges Photos */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.CADChanges).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> CAD Changes</div>
                                            :
                                            this.state.CADChangesError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading CAD Changes: <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.CADChanges)}><FontAwesomeIcon icon={faCircle} /> CAD Changes</button>
                                        }
                                    </td>
                                    <td className="w-25"><label htmlFor="CADChanges" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="CADChanges" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'CADChanges', 'CADChangesError')} /></td>
                                    <td className="w-25"><label htmlFor="CADChangesUpload" className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="CADChangesUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'CADChanges', 'CADChangesError')}/></td>
                                </tr>

                                {/* CADChanges Array Photos */}
                                {
                                    this.state.CADChangesArray.length !== 0 ? 
                                    
                                    this.state.CADChangesArray.map(t =>
                                        <tr key={t}>
                                            <td className="w-50">
                                                {
                                                    Object.keys(this.state[t]).length === 0 ?
                                                    <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> {t}</div>
                                                    :
                                                    <button className='btn btn-outline text-green btn-text' onClick={() => this.previewImage(this.state[t])}><FontAwesomeIcon icon={faCircle} /> {t}</button>
                                                }
                                            </td>
                                            <td className="w-25"><label htmlFor={t} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id={t} type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], t)} /></td>
                                            <td className="w-25"><label htmlFor={t + 'Upload'} className="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id={t + 'Upload'} type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], t)}/></td>
                                        </tr>
                                    )
                                    :
                                    <></>
                                }
                                <tr>
                                    <td className="w-50">Add Another CAD Changes Pic</td>
                                    <td className="w-25"><button className='btn btn-primary' onClick={() => this.addAnotherPic('CADChangesArray', 'CADChanges-', '')}>Add <FontAwesomeIcon icon={faPlus} /></button></td>
                                    <td className="w-25"></td>
                                </tr>

                                {/* Yard Sign Photo */}
                                <tr>
                                    <td className="w-50">
                                        {
                                            Object.keys(this.state.YardSign).length === 0 ?
                                            <div className='text-warningC'><FontAwesomeIcon icon={faCircle} /> Yard Sign: V3 yard sign installed in front of the home, visible, and is not hindering any paths </div>
                                            :
                                            this.state.YardSignError ?
                                            <div className='text-error'><FontAwesomeIcon icon={faCircle} /> Error Uploading : <br></br>{this.state.errorMessage}</div>
                                            :
                                            <button className='btn btn-outline text-green' onClick={() => this.previewImage(this.state.YardSign)}><FontAwesomeIcon icon={faCircle} /> Yard Sign: V3 yard sign installed in front of the home, visible, and is not hindering any paths </button>
                                        }
                                    </td>
                                    <td className="w-25"><label for="YardSign" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Take Picture</label><input className={css.PhotoPack__PicInput} id="YardSign" type="file" accept="image/*" disabled={this.state.uploading} capture="environment" onChange={(event) => this.capturePhoto(event.target.files[0], 'YardSign', 'YardSignError')} /></td>
                                    <td className="w-25"><label for="YardSignUpload" class="btn btn-primary"><div className={this.state.uploading ? css.PhotoPack__Uploading : 'd-none'}></div>Upload from Phone</label><input className={css.PhotoPack__PicInput} id="YardSignUpload" type="file" accept="image/*" disabled={this.state.uploading} onChange={(event) => this.capturePhoto(event.target.files[0], 'YardSign', 'YardSignError')}/></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Slack div to send messages */}
                        <div className='py-3'>
                            <button className='btn btn-primary' disabled={this.state.sendingToSlack} onClick={() => this.sendToSlack()}>Notify Office for Review</button>
                        </div>
                        <div className={this.state.slackResponse !== '' ? 'py-3' : 'd-none'}>
                            <p className='text-white'>{this.state.slackResponse}</p>
                        </div>
                        <div className={this.state.sendingToSlack ? 'py-3' : 'd-none'}>
                            <div className={css.PhotoPack__Loader}></div>
                        </div>
                    </div>
                }

                <h2 className={this.state.errorMessage !== '' ? 'text-error' : 'd-none'} style={{ whiteSpace: 'pre-line' }}>Error: {this.state.errorMessage}</h2>

            </div>
        )
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(InstallPhotoPack);